import * as Yup from 'yup';

export const accommodationOfferRoomTypeValidationSchema = Yup.object().shape({
    
});

export const accommodationOfferRoomValidationSchema = Yup.object().shape({
    
});
